import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import "../styles/MapReportsStatus.css";

interface MapReportsStatusProps {
  reportsLoading: boolean;
  reportsError: string | null;
  reportsCount: number;
  markersCount: number;
  markersCreated: boolean;
}

const MapReportsStatus: React.FC<MapReportsStatusProps> = memo(
  ({
    reportsLoading,
    reportsError,
    reportsCount,
    markersCount,
    markersCreated,
  }) => {
    const { t } = useTranslation();
    
    return (
      <div className="reports-status">
        {reportsLoading && <p>{t("common.loading")}</p>}
        {reportsError && (
          <p className="error-text">{t("errors.failedToLoadMap")}: {reportsError}</p>
        )}
        {!reportsLoading && !reportsError && (
          <p>
            {t("map.reportsOnMap")}: {reportsCount}
            {markersCreated && ` • ${markersCount} ${t("map.reportsOnMap")}`}
          </p>
        )}
      </div>
    );
  }
);

MapReportsStatus.displayName = "MapReportsStatus";

export default MapReportsStatus;
